export default __webpack_public_path__ + "static/media/covariance-matrix-icon.b295b80c.svg";